import { Button } from '@cian/ui-kit/button';
import styles from './AllFiltersModalFooter.css';
import { FC } from 'react';

interface IAllFiltersModalFooterProps {
  searchButtonText: string;
  isCounterRefreshing: boolean;
  onClearClick(): void;
  onShowClick(): void;
  professionalSearchUrl?: string;
}

export const AllFiltersModalFooter: FC<IAllFiltersModalFooterProps> = ({
  onClearClick,
  onShowClick,
  isCounterRefreshing,
  searchButtonText,
}) => {
  const buttons = (
    <>
      <Button size="XS" theme="fill_white_primary" onClick={onClearClick}>
        Сбросить фильтры
      </Button>
      <Button size="XS" theme="fill_primary" onClick={onShowClick} loading={isCounterRefreshing}>
        {searchButtonText}
      </Button>
    </>
  );

  return (
    <div className={styles['container']} data-testid="AllFiltersModalFooter" data-name="AllFiltersModalFooter">
      {buttons}
    </div>
  );
};
